import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const addPayrollOrderCommentMutation = gql`
  mutation AddPayrollOrderComment($order_id: ID!, $comment: String!) {
    addPayrollOrderComment(order_id: $order_id, comment: $comment)
  }
`

export const addPayrollOrderCommentKey = getQueryNames(addPayrollOrderCommentMutation)[0]
